import { Plus } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from '../Icon.types';

const PlusIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <Plus width={size} height={size} color={color} {...rest} />;

export default PlusIcon;
